import $ from 'jquery';
const ERROR_CLASS = 'is-error';
const ARIA_INVALID = 'aria-invalid';

export default function(selector) {
  const zipField = $(selector);
  let isValid = true;
  if (zipField.length > 0) {
    const zipCode = zipField.val();
    const valid = /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipCode);
    if (!valid) {
      zipField.closest('.field').addClass(ERROR_CLASS);
      zipField.attr(ARIA_INVALID, true);
      isValid = false;
    } else {
      zipField.closest('.field').removeClass(ERROR_CLASS);
      zipField.attr(ARIA_INVALID, false);
    }
  }
  return isValid;
};



// WEBPACK FOOTER //
// ./src/scripts/modules/validate-zip-code.js